/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@mui';
import { makeStyles } from '@material-ui/core/styles';
import { moreListTooltipStyles } from '@constants/mui-theme';
import { enDash } from '@utils/shared-utils';
import './list-more.scss';

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    ...moreListTooltipStyles.tooltip,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
  }
}));

const ListMore = ({ dataType, limit = 1, list }) => {
  const classes = useStyles();
  const [anchorPosition, setAnchorPosition] = useState(null);

  const handleMouseEnter = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    setAnchorPosition(null);
  }, []);

  const handleMouseMove = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const open = Boolean(anchorPosition);

  const renderItem = (item, index) => (
    <div key={index} style={moreListTooltipStyles.itemStyle}>
      {item}
    </div>
  );

  const renderList = items => (
    <div>
      {items.slice(0, 6).map((item, index) => renderItem(item, index))}
      {items.length > 6 && (
        <div style={moreListTooltipStyles.seeDetailsStyle}>
          See {dataType} detail for complete list
        </div>
      )}
    </div>
  );

  if (!list) {
    return null;
  }

  let display = [];
  let more = 0;
  if (list.length <= limit) {
    display = list;
  } else {
    display = list.slice(0, limit);
    more = list.length - limit;
  }

  return (
    <div data-testid="list-more" styleName="column-renderer-list-more-container">
      {display.length > 0 && display.map((item, index) => (
        <span data-testid="list-more-item" key={index} styleName="item">
          {item}
        </span>
      ))}
      {more > 0 && (
        <span
          data-testid="list-more-item-last"
          onMouseOver={handleMouseEnter}
          onMouseOut={handleMouseLeave}
          onMouseMove={handleMouseMove}
          styleName="last"
        >
          +{more}
        </span>
      )}
      {display.length === 0 && <span>{enDash}</span>}
      <Popover
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition || { top: 0, left: 0 }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        disableRestoreFocus
      >
        {renderList(list.slice(limit))}
      </Popover>
    </div>
  );
};

ListMore.propTypes = {
  dataType: PropTypes.string,
  limit: PropTypes.number,
  list: PropTypes.array
};

export default ListMore;
